import React from 'react';

import { FaUtensils } from 'react-icons/fa';
import { svg } from '../assets/svg';
import { hooks } from '../hooks';
import type { DishType } from '../types';
import { getItemFromLocalStorage } from '../utils/getItemFromLocalStorage';

type Props = {
  dish: DishType;
  isLast: boolean;
};

export const OrderItem: React.FC<Props> = ({dish, isLast}) => {
  const navigate = hooks.useNavigate();
  const MENU_CONFIG=getItemFromLocalStorage("menuConfiguration")

  const {addToCart, removeFromCart, getDishQty} = hooks.useCartHandler();

  return (
    <li
      style={{
        backgroundColor: '#ffffff',
        borderRadius: 18,
        padding: 16,
        display: 'flex',
        alignItems: 'center',
        minHeight: 120,
        flexDirection: 'row',
        marginBottom: isLast ? 0 : 16,
        position: 'relative',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
        border: '1px solid rgba(0, 0, 0, 0.05)',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
      }}
      onClick={() => navigate(`/dish/${dish.id}`, {state: {dish}})}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.1)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 2px 12px rgba(0, 0, 0, 0.06)';
      }}
    >
      {dish.image ? (
        <img
          src={dish.image}
          alt={dish.name}
          style={{ 
            width: 100, 
            height: 100, 
            borderRadius: 14, 
            marginRight: 16, 
            objectFit: "cover",
            flexShrink: 0,
          }}
        />
      ) : (
        <div
          style={{
            width: 100,
            height: 100,
            borderRadius: 14,
            background: "linear-gradient(135deg, #f5f7fa 0%, #e4e7eb 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: 16,
            flexShrink: 0,
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          {/* Decorative background element */}
          <div
            style={{
              position: "absolute",
              width: "150%",
              height: "150%",
              background: "radial-gradient(circle, rgba(255,255,255,0.8) 0%, transparent 70%)",
              top: "-25%",
              left: "-25%",
              opacity: 0.5,
            }}
          />
          <FaUtensils
            style={{
              color: "#b0b8c1",
              fontSize: "28px",
              opacity: 0.8,
              position: 'relative',
              zIndex: 1,
              filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.05))",
            }}
          />
        </div>
      )}
     
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          marginRight: 'auto',
          height: '100%',
          justifyContent: 'center',
          gap: 6,
          flex: 1,
          minWidth: 0,
        }}
      >
        <span style={{
          fontFamily: 'DM Sans, sans-serif',
          fontSize: 16,
          fontWeight: 600,
          color: 'var(--main-color)',
          lineHeight: 1.3,
        }}>
          {dish.name}
        </span>
        {MENU_CONFIG.isInfoSupported && (
          <span style={{
            fontFamily: 'DM Sans, sans-serif',
            fontSize: 13,
            color: '#999',
            fontWeight: 400,
          }}>
            {dish.kcal} kcal - {0}g
          </span>
        )}
        <span style={{
          fontFamily: 'DM Sans, sans-serif',
          fontSize: 17,
          color: 'var(--main-turquoise)',
          fontWeight: 700,
        }}>
          ₹{dish.isFullPrice !== false ? dish.price : dish.halfPrice}
        </span>
      </div>
      <div
        style={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexShrink: 0,
        }}
      >
        <button
          style={{padding: '14px 14px 4px 14px', borderRadius: 4}}
          onClick={(event) => {
            removeFromCart(dish, event);
          }}
        >
          <svg.RemoveSvg />
        </button>
        <span style={{
          fontFamily: 'DM Sans, sans-serif',
          fontSize: 16,
          fontWeight: 700,
          color: 'var(--main-color)',
          lineHeight: 1,
          minWidth: 24,
          textAlign: 'center',
        }}>
          {getDishQty(dish.id ?? 0, dish.isFullPrice !== false)}
        </span>
        <button
          style={{padding: '4px 14px 14px 14px', borderRadius: 4}}
          onClick={(event) => {
            addToCart(dish, event);
          }}
        >
          <svg.AddSvg />
        </button>
      </div>
      {/* {dish.isChefSpecial && (
        <img
          alt='New'
          src={require('../assets/icons/14.png')}
          style={{
            width: 34,
            left: 7,
            top: 7,
            height: 'auto',
            position: 'absolute',
          }}
        />
      )} */}
      {/* {dish.availability && (
        <>
          {dish.category === "Veg" ? (
            <img
              alt="Veg"
              src={require("../assets/Filters/veg.png")}
              style={{
                width: "24px",
                left: 1,
                top: 5,
                marginLeft: 14,
                marginTop: 14,
                height: "24px",
                position: "absolute",
              }}
            />
          ) : (
            <img
              alt="Non-Veg"
              src={require("../assets/Filters/non-veg.png")}
              style={{
                width: "24px",
                left: 1,
                top: 5,
                marginLeft: 14,
                marginTop: 14,
                height: "24px",
                position: "absolute",
              }}
            />
          )}
        </>
      )} */}
      {/* {dish.isHot && (
        <img
          alt='Hot'
          src={require('../assets/icons/15.png')}
          style={{
            width: 34,
            left: 7,
            top: 7,
            height: 'auto',
            position: 'absolute',
          }}
        />
      )} */}
    </li>
  );
};
